import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "app-upgrade-preview-cta",
  templateUrl: "./upgrade-preview-cta.component.html",
  styleUrls: ["./upgrade-preview-cta.component.css"],
})
export class UpgradePreviewCtaComponent {
  @Input() title = "Preview Mode";
  @Input() description = "";
  @Input() hiddenRowsCount = 0;
  @Input() buttonLabel = "Upgrade Now";
  @Output() ctaClick = new EventEmitter<void>();

  onCtaClick(): void {
    this.ctaClick.emit();
  }
}
